/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';

export const getFiles = (feature: BaseFeature): string[] => {
    return [
        'src/index.html',
        'sections-rom.ld',
    ];
};

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    if (feature.getSettingValue('ENABLED').toString() === '0') {
        return blocks;
    }

    const DEBUG_PRINT = feature.getSettingValue('DEBUG_PRINT').toString() === '1';

    blocks.push({
        location: 'PRJ_CONF',
        blockType: BlockType.CODE,
        template: `
CONFIG_HTTP_SERVER=y
CONFIG_NET_SOCKETS_POLL_MAX=10
CONFIG_NET_CONNECTION_MANAGER=y
CONFIG_NET_TCP_TIME_WAIT_DELAY=0
CONFIG_NET_MAX_CONN=10
# CONFIG_NET_HTTP_SERVER_LOG_LEVEL_DBG=y

CONFIG_DNS_RESOLVER=y
CONFIG_DNS_RESOLVER_AI_MAX_ENTRIES=10


CONFIG_HTTP_SERVER_MAX_CLIENTS=2
CONFIG_HTTP_SERVER_MAX_STREAMS=2
`,
    });

    blocks.push({
        location: 'CMAKE',
        blockType: BlockType.CODE,
        template: `
zephyr_linker_sources(SECTIONS sections-rom.ld)
zephyr_linker_section(NAME http_resource_desc_my_service
                      KVMA RAM_REGION GROUP RODATA_REGION
                      SUBALIGN Z_LINK_ITERABLE_SUBALIGN)


set(gen_dir \${ZEPHYR_BINARY_DIR}/include/generated/)
set(source_file_index src/index.html)
generate_inc_file_for_target(app \${source_file_index} \${gen_dir}/index.html.gz.inc --gzip)
`,
    });

    blocks.push({
        location: 'GLOBAL_INCLUDES',
        blockType: BlockType.CODE,
        template: `
#include <zephyr/net/net_context.h>
#include <zephyr/net/net_core.h>        
#include <zephyr/net/http/server.h>
#include <zephyr/net/http/service.h>
`,
    });

    blocks.push({
        location: 'GLOBAL_DEFINES',
        blockType: BlockType.CODE,
        template: `
static uint16_t http_service_port = 80;

HTTP_SERVICE_DEFINE(my_service, "0.0.0.0", &http_service_port, 2, 10, NULL);

static const uint8_t index_html_gz[] = {
    #include "index.html.gz.inc"
};

struct http_resource_detail_static index_html_gz_resource_detail = {
    .common = {
        .bitmask_of_supported_http_methods = BIT(HTTP_GET),
        .type = HTTP_RESOURCE_TYPE_STATIC,
        .content_encoding = "gzip",
    },
    .static_data = index_html_gz,
    .static_data_len = sizeof(index_html_gz),
};

HTTP_RESOURCE_DEFINE(index_html_gz_resource, my_service, "/",
                     &index_html_gz_resource_detail);
`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
http_server_start();
`,
    });

    blocks.push({
        location: 'GLOBAL_DEFINES',
        blockType: BlockType.CODE,
        template: `
#define HTTP_DEBUG_PRINT ${DEBUG_PRINT}
`,
    });

    // const ENDPOINTS = feature.getSettingValue('ENDPOINTS');
    // for (let i = 0; i < ENDPOINTS.length; i++) {
    //     blocks = blocks.concat(ENDPOINTS[i].getCodeBlocks());
    // }

    return blocks;
};
